import React, { useEffect } from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'
import Breadcrumb from '../../components/Breadcrumb'
import TopCountries from '../../components/child/TopCountries'
import axios from 'axios'
import { BaseUrl } from '../../helper/apiHelper'
import toast from 'react-hot-toast'
import { useState } from 'react'
import SupportTracket from './SupportTracket'
import TopCategories from './TopCategories'
import UserOverview from './UserOverview'
import RevenueInsigts from "./RevenueInsigts"
import UserDetails from './UserDetails'
import './Dashboard.css'
const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState();
  const [topCountryStates, setTopCountryStates] = useState();
  const [topCategories, setTopCategories] = useState([])
  const [support, setSupport] = useState([])
  const [users, setUsers] = useState([])
  const [revenueReport, setRevenueReport] = useState([])
  const [loading, setLoading] = useState(false); // Add loading state
  const getDashboardDetails = async () => {
    setLoading(true); // Start loading
    try {
      let body = {};
      let response = await axios.post(
        `${BaseUrl}/get-master-dashboard-details`,
        body
      );
      if (response.status === 200) {

        setRevenueReport(response.data.data.revenueReport);
        setUsers(response.data.data.users)
        setTopCategories(response.data.data.topCategories)
        setSupport(response.data.data.support)
        setDashboardData(response.data.data);
        setTopCountryStates(response.data.data.ordersCountryStates);
      }
    } catch (error) {
      toast.error(error.response.data.message);

    }

    finally {
      setLoading(false); // Stop loading
    }
  };
  useEffect(() => {
    getDashboardDetails();
  }, [])
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Dashboard" />
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              minHeight: "calc(100vh - 300px)",
              width: "100%",
              background: "transparent",
            }}
          >
            <div
              className="spinner-border"
              role="status"
              style={{
                color: "#243E85",
                width: "3rem",
                height: "3rem",
              }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="row gy-4 " style={{ marginBottom: "24px" }}>
              <RevenueInsigts revenueReport={revenueReport} />
              <TopCountries topCountryStates={topCountryStates} />
              {/* <SupportTracket support={support} />
            <TopCategories topCategories={topCategories} />
         
            <UserDetails users={users} /> */}
            </div>

            <div className='grid-col'>
              <SupportTracket support={support} />
              <TopCategories topCategories={topCategories} />

              <UserDetails users={users} />
            </div>
          </>
        )}
      </MasterLayout>
    </>
  );
}

export default Dashboard